import "@/polyfills"; // MUST be first — defines Buffer/global before the Solana SDK loads
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";
import "@/styles.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("OmniBridge Ops: #root element missing from index.html");
}
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
